import recentStoresFlyoutSaga from './recentStoresFlyout';

export default recentStoresFlyoutSaga;
